import React, {Component} from 'react';
import {Row, Col} from "react-bootstrap";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../../utilities/TabGrid";
import acc from 'accounting'

export default class BezPrzesiadkiTable extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    renderERezerwacja(cell,row){
        if(Boolean(cell)){
            return <span style={{color:'forestgreen'}}><i className={'fa fa-check'}></i> dostępna</span>
        } else return <span style={{color:'firebrick'}}><i className={'fa fa-times'}></i> brak</span>
    }

    renderEBilet(cell,row){
        if(Boolean(cell)){
            return <span style={{color:'forestgreen'}}><i className={'fa fa-check'}></i> dostępny</span>
        } else return <span style={{color:'firebrick'}}><i className={'fa fa-times'}></i> brak</span>
    }

    render() {

        return (
            <div>
                <BootstrapTable data={this.props.data}
                                hover
                                options={{noDataText: 'Brak pasujących rekordów'}}
                >
                    <TableHeaderColumn dataField='idKu' isKey dataSort
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                    >Nr kursu</TableHeaderColumn>
                    <TableHeaderColumn dataField='nazTr' dataSort
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                    >Trasa</TableHeaderColumn>
                    <TableHeaderColumn dataField='nazMiOd'
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                    ><i className={'fa fa-sign-in'}></i> Miejscowość od</TableHeaderColumn>
                    <TableHeaderColumn dataField='nazMiDo'
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                    ><i className={'fa fa-sign-out'}></i> Miejscowość do</TableHeaderColumn>
                    <TableHeaderColumn dataField='godz'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                    ><i className={'fa fa-sign-in'}></i> Odjazd</TableHeaderColumn>
                    <TableHeaderColumn dataField='godzPrzy'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                    ><i className={'fa fa-sign-out'}></i> Przyjazd</TableHeaderColumn>
                    <TableHeaderColumn dataField='ileMin'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                    ><i className={'fa fa-sign-out'}></i> Czas trwania</TableHeaderColumn>
                    <TableHeaderColumn dataField='cena' dataSort
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       dataFormat={(cell,row)=>{return acc.formatMoney(cell)}}
                    >Cena</TableHeaderColumn>
                    {/*<TableHeaderColumn dataField='czyERezerwacja' dataSort
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       dataFormat={this.renderERezerwacja}
                    >e-rezerwacja?</TableHeaderColumn>
                    <TableHeaderColumn dataField='czyEBilet' dataSort
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       dataFormat={this.renderEBilet}
                    >e-bilet?</TableHeaderColumn>*/}
                </BootstrapTable>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/szukaj/components/BezPrzesiadkiTable.js